import React from 'react';
import { Inbox } from 'lucide-react';

interface EmptyStateProps {
  title: string;
  description?: string;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, description, className = '' }) => (
  <div
    className={`flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-slate-50/80 px-8 py-14 text-center ${className}`}
  >
    <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-white shadow-sm ring-1 ring-slate-100">
      <Inbox className="h-7 w-7 text-slate-400" aria-hidden />
    </div>
    <p className="text-base font-semibold text-slate-800">{title}</p>
    {description ? <p className="mt-2 max-w-sm text-sm text-slate-500">{description}</p> : null}
  </div>
);

export default EmptyState;
